export { AtnConditionsTabComponent as Component } from './conditions-tab.component'
